module.exports = "<p>time-picker works!</p>\n"